module.exports = __webpack_public_path__ + "img/zniber.56e77f65.png";